<!-- <li class="panel"> -->
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(altraParte)"
				class="btn btn-primary associa" type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-3">{{ altraParte.parte.nominativo }}</h4>
		<p class="col-sm-3">
			CF/P.IVA: <strong>{{ altraParte.parte?.codiceFiscale}}</strong>
		</p>
		<p class="col-sm-2">
			<strong>{{altraParte.categoriaAltraParte?.label}}</strong>
		</p>
		<ng-template [ngIf]="altraParte.ritirato">
		<p class="col-sm-2 status">NON ATTIVO</p>
		</ng-template>
	</div>
</div>
<!-- </li> -->
